import React, { memo } from 'react';
import { IForecastCard } from '../../common/types';
import { HourCardListDay } from './hourCardListDay';
import { HourCardSmall } from './hourCardSmall';

interface HourCardViewSmallProps extends IForecastCard {
    cardIndex: number;
    displayWeekday: boolean;
}

export const HourCardViewSmall = memo(({ 
    iconCode, 
    hour, 
    temperature, 
    precipitation, 
    description,
    cardIndex,
    humidity, 
    wind, 
    dewPoint,
    day,
    displayWeekday, 
    feelsLike }: HourCardViewSmallProps) => {

    return (
        <>
            {
                displayWeekday && day && <HourCardListDay weekday={day} key={`hour-card-week-day#${day}-${cardIndex}`} />
            }
            <HourCardSmall 
                key={`hourly-card_small#${cardIndex}`}
                cardIndex={cardIndex}
                day={day}
                dewPoint={dewPoint}
                temperature={temperature}
                hour={hour}
                description={description}
                humidity={humidity}
                wind={wind}
                precipitation={precipitation}
                iconCode={iconCode}
                feelsLike={feelsLike} />
        </>
    );
});

HourCardViewSmall.displayName = 'HourCardViewSmall';
